import type { PropsWithChildren } from "react";

import type { IconName } from "@similarweb/icons";

import { StyledEnrichmentEmptyStateIcon, StyledEmptyState, StyledInnerContentWrapper } from "./style";

type Props = PropsWithChildren<{
    title: string;
    subtitle: string;
    iconName: IconName;
}>;

const SectionEmptyState = ({ iconName, title, subtitle, children }: Props) => {
    const renderEmptyIcon = () => <StyledEnrichmentEmptyStateIcon iconName={iconName} />;

    const renderCtaButtons = () => <StyledInnerContentWrapper>{children}</StyledInnerContentWrapper>;

    return (
        <StyledEmptyState
            title={title}
            subtitle={subtitle}
            SvgImage={renderEmptyIcon}
            CtaButtons={renderCtaButtons}
        />
    );
};

export default SectionEmptyState;
